<div id="{{idPrefix + idSuffix}}"
     class="row no-gutters dr-checkbox"
     [ngClass]="{ 'disabled': disabled, 'invalid': invalid }"
     (click)="toggleSelected(pubBoolValue)"
     [ngStyle]="{'width': width ? width : '100%' }">

    <div class="col-9 dr-checkbox-column-left">
        <span>{{ label | translate }}</span>
    </div>

    <div class="col-3 dr-checkbox-column-right">
        <mat-checkbox #matCheckBox
                      id="{{idPrefix + idSuffix}}.selected"
                      color="accent"
                      class="dr-checkbox-input"
                      [disabled]="disabled"
                      [checked]="pubBoolValue">
        </mat-checkbox>
    </div>

</div>
